/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiEntityOrder } from './InternalApiEntityOrder';
import {
    InternalApiEntityOrderFromJSON,
    InternalApiEntityOrderFromJSONTyped,
    InternalApiEntityOrderToJSON,
    InternalApiEntityOrderToJSONTyped,
} from './InternalApiEntityOrder';
import type { InternalApiEntityType } from './InternalApiEntityType';
import {
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeFromJSONTyped,
    InternalApiEntityTypeToJSON,
    InternalApiEntityTypeToJSONTyped,
} from './InternalApiEntityType';

/**
 * 
 * @export
 * @interface InternalApiEntitySchemaFieldOrder
 */
export interface InternalApiEntitySchemaFieldOrder {
    /**
     * 
     * @type {InternalApiEntityType}
     * @memberof InternalApiEntitySchemaFieldOrder
     */
    entityType: InternalApiEntityType;
    /**
     * 
     * @type {Array<InternalApiEntityOrder>}
     * @memberof InternalApiEntitySchemaFieldOrder
     */
    internalApiEntityOrder: Array<InternalApiEntityOrder>;
}



/**
 * Check if a given object implements the InternalApiEntitySchemaFieldOrder interface.
 */
export function instanceOfInternalApiEntitySchemaFieldOrder(value: object): value is InternalApiEntitySchemaFieldOrder {
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('internalApiEntityOrder' in value) || value['internalApiEntityOrder'] === undefined) return false;
    return true;
}

export function InternalApiEntitySchemaFieldOrderFromJSON(json: any): InternalApiEntitySchemaFieldOrder {
    return InternalApiEntitySchemaFieldOrderFromJSONTyped(json, false);
}

export function InternalApiEntitySchemaFieldOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiEntitySchemaFieldOrder {
    if (json == null) {
        return json;
    }
    return {
        
        'entityType': InternalApiEntityTypeFromJSON(json['entityType']),
        'internalApiEntityOrder': ((json['internalApiEntityOrder'] as Array<any>).map(InternalApiEntityOrderFromJSON)),
    };
}

export function InternalApiEntitySchemaFieldOrderToJSON(json: any): InternalApiEntitySchemaFieldOrder {
    return InternalApiEntitySchemaFieldOrderToJSONTyped(json, false);
}

export function InternalApiEntitySchemaFieldOrderToJSONTyped(value?: InternalApiEntitySchemaFieldOrder | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityType': InternalApiEntityTypeToJSON(value['entityType']),
        'internalApiEntityOrder': ((value['internalApiEntityOrder'] as Array<any>).map(InternalApiEntityOrderToJSON)),
    };
}

